import { render, staticRenderFns } from "./set.vue?vue&type=template&id=c1338348&scoped=true"
import script from "../js/set.js?vue&type=script&lang=js&external"
export * from "../js/set.js?vue&type=script&lang=js&external"
import style0 from "./set.vue?vue&type=style&index=0&id=c1338348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1338348",
  null
  
)

export default component.exports